import styled, { css } from 'styled-components';
import { ButtonProp } from '@types';
import memoize from 'fast-memoize';
const edgesFun = memoize((edges: string) => {
    switch (edges) {
        case 'rounded':
            return '100rem';
        case 'square':
            return '5px';
        default:
            return '7px';
    }
});

const getStyle = memoize((textColor: string, bgColor: string, variant: string) => {
    return css`
        color: ${textColor};
        background: ${bgColor};
        border: 0.2rem solid ${variant === 'solid' ? bgColor : textColor};
    `;
});

const stylesDef = memoize((theme: any, themeType: string, variant: string, color: string) => {
    if (themeType) {
        const { textColor, bgColor } = theme['button'][themeType];
        return getStyle(textColor, bgColor, bgColor);
    } else if (variant == 'outlined') {
        return getStyle(color || theme.colors.blue, theme.colors.white, variant);
    } else if (variant == 'solid') {
        return getStyle(theme.colors.white, color || theme.colors.blue, variant);
    } else {
        return getStyle(color || theme.colors.black, theme.colors.white, variant);
    }
});

export const StyledButton = styled.button<ButtonProp>`
    text-transform: ${({ textTransform }) => textTransform || 'uppercase'};
    font-weight: ${({ theme, fontWeight }) => theme['font']['weights'][fontWeight] || theme?.font?.weights?.Regular};
    letter-spacing: 0;
    line-height: 1.313rem;
    font-size: 1.125rem;
    height: 3.5rem;
    padding: 0.5rem 2rem;
    width: ${({ width }) => (width ? width : '9.688rem')};
    border-radius: ${({ edges }) => edgesFun(edges)};
    ${({ theme, themeType, variant, color }) => stylesDef(theme, themeType, variant, color)};

    @media screen and (max-width: 425px) {
        width: ${({ mobileWidth }) => mobileWidth || '11.5rem'};
    }
`;
